<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'customer'
    }
</script>

<style lang="scss" scoped>

</style>